import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import ServiceCard from "./ServiceCard";

// Animation Variants
const itemVariant = {
  hiddenLeft: { opacity: 0, x: -50 }, // Keep original distance
  hiddenRight: { opacity: 0, x: 50 }, // Keep original distance
  visible: (delay) => ({
    opacity: 1,
    x: 0,
    transition: { duration: 0.8, ease: "easeOut", delay },
  }),
};

const ServicesSection = () => {
  const services_area_list = [
    {
      title: "Frontend Development",
      desc: "Creating responsive and interactive web applications using React, HTML, CSS, and JavaScript.",
      url: "/services-details",
      delay_time: 0.2,
    },
    {
      title: "Backend Development",
      desc: "Building scalable server-side applications and REST APIs with Node.js, Express, and Flask.",
      url: "/services-details",
      delay_time: 0.4,
    },
    {
      title: "UI/UX Design",
      desc: "Designing user-friendly and visually appealing interfaces with a strong focus on user experience.",
      url: "/services-details",
      delay_time: 0.6,
    },
    {
      title: "Mobile App Development",
      desc: "Building cross-platform mobile applications using React Native for Android and iOS.",
      url: "/services-details",
      delay_time: 1.0,
    },
  ];

  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 670);
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div style={{ overflowX: "hidden" }}> {/* Added wrapper with overflowX hidden */}
      <section className="services-area pt-35" style={{ paddingBottom: isMobile ? 0 : 100 }}>
        <div className="container">
          <div className="row justify-content-center">
            {services_area_list.map((item, index) => (
              <motion.div
                key={index}
                className="col-xl-3 col-lg-4 col-md-6 col-sm-10"
                variants={itemVariant}
                initial={index % 2 === 0 ? "hiddenLeft" : "hiddenRight"}
                whileInView="visible"
                viewport={{ once: true, amount: 0.3 }}
                custom={item.delay_time}
                style={{
                  display: isMobile && "flex",
                  justifyContent: isMobile && "center",
                }}
              >
                <ServiceCard index={index} item={item} />
              </motion.div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default ServicesSection;